import { Link } from "react-router-dom";
import { useTranslation } from "../../../i18n/LanguageProvider";

function WomanNotFound() {
    const { t, localizedPath } = useTranslation();

    return (
        <div className="woman-page__not-found card-common">
            <h2>{t("profile.notFound")}</h2>
            <Link to={localizedPath("/")} className="woman-page__back">
                {t("profile.backHome")}
            </Link>
        </div>
    );
}

export default WomanNotFound;
